const classer = (classes) =>
  Array.isArray(classes) ? classes.filter(Boolean).join(' ') : '';

export default classer;
